import { IProductTitle, TClientProduct, TProductSplit } from 'shared/types';

export const parseProductsAliases = (products: TClientProduct[], isUpc = false) => {
    return products.map((product) => {
        const productTitle: IProductTitle = {
            ean: product.ean,
            name: product.name,
            ...(isUpc ? { upc: product.upc || product.ean } : {}),
        };

        product.name_split.splits?.forEach((split, index) => {
            productTitle[`name_split_${index + 1}`] = split;
        });

        return productTitle;
    });
};

export const showTitleWithAlias = (title: TProductSplit) => {
    if (title.aliases) return `${title.val};${title.aliases.join(';')}`;
    return title.val;
};
